<template>
    <div>
        <el-form  :label-width="!$store.getters.isPC ? '0px' : '210px'" :label-position="!$store.getters.isPC ? 'top' : 'left'" ref="dynamicValidateForm" :model="formLabelAlign">
        <el-form-item label="App. ID 申請編號">
            <div class="text-details">{{formLabelAlign.registrationNo}}</div>
            <!-- <el-input disabled v-model="formLabelAlign.registrationNo"></el-input> -->
        </el-form-item>
        <el-form-item label="Student Name 學生姓名">
            <div v-if="formLabelAlign.applicantName" class="text-details">{{JSON.parse(formLabelAlign.applicantName).en || ''}}</div>
            <!-- <el-input disabled v-model="formLabelAlign.region"></el-input> -->
        </el-form-item>
        <el-form-item label="App. Form 申請表">
            <div v-if="formLabelAlign.eventStatus" class="text-details">{{formLabelAlign.eventStatus.title}}</div>
            <!-- <el-input disabled v-model="formLabelAlign.formType"></el-input> -->
        </el-form-item>
        <el-form-item label="App. Status 申請狀況">
            <div class="text-details">{{formLabelAlign.status | applicationStatus }}</div>
            <!-- <el-input disabled v-model="formLabelAlign.status"></el-input> -->
        </el-form-item>
        <el-form-item label="App. Period 申請時間">
            <div class="text-details">{{formLabelAlign.applyAt | formatDate}}</div>
            <!-- <el-input disabled v-model="formLabelAlign.applyAt"></el-input> -->
        </el-form-item>
        <el-form-item label="Amendment Detail 修改詳請" prop="detail"  :rules="[
            { required: true, message: 'The detail cannot be empty.  請填寫此字段。', trigger: 'blur' },
            ]">
            <el-input type="textarea" :rows="10" v-model="formLabelAlign.detail"></el-input>
        </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            formLabelAlign: {
                type: Object,
                default: function(){},
            },
        },
        data() {
            return {
               
            }
        },
        methods:{
            getApplicationStudentName(row){
                let newValue =  row.filter((v)=>{
                     return v.type == 0
                })[0]
                return newValue
            },
        }
    }
</script>

<style lang="scss" scoped>
.text-details{
    min-height: 40px;
    padding: 10px;
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
    cursor: not-allowed;
    border-radius: 5px;
    text-align: left;
}
</style>